import { createFileRoute } from "@tanstack/react-router";
import { Welcome } from "@/app/welcome/welcome";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/welcome"
)({
  component: Welcome,
  loader: () => ({
    crumb: "Welcome",
  }),
});
